import { T, Var } from 'gt-react';
import { formatSnoozedUntil } from './invoiceSnooze';
import { readInvoiceSnoozeAudit } from './invoiceSnoozeAudit';

/** Timeline sentence for a snooze or a clear. Other fields stay in the row. */
export function InvoiceSnoozeChangeLine({
  changedFields,
}: {
  changedFields: Record<string, unknown> | null | undefined;
}) {
  const snooze = readInvoiceSnoozeAudit(changedFields);
  if (snooze?.kind === 'snoozed' && snooze.until) {
    return (
      <div className="text-xs text-muted-foreground">
        <T context="invoice timeline entry when someone snoozes the invoice">
          Snoozed until <Var>{formatSnoozedUntil(snooze.until)}</Var>
        </T>
        {snooze.note ? <SnoozeNote note={snooze.note} /> : null}
      </div>
    );
  }
  if (snooze?.kind === 'cleared') {
    return (
      <div className="text-xs text-muted-foreground">
        <T context="invoice timeline entry when a snooze is cleared">
          Snooze cleared
        </T>
      </div>
    );
  }
  return null;
}

function SnoozeNote({ note }: { note: string }) {
  return (
    <>
      {' '}
      <T context="invoice timeline entry, the note left with a snooze">
        — <Var>{note}</Var>
      </T>
    </>
  );
}
